import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { resetPromotion, setCurrentConfigCode, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function LogoutService() {
    const { promotionSlug } = useSelector(state => state.configurator);
    const userMutation = UserService();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useMutation(['logoutQuery'], () => {
        const logoutUrl = `${EndPoints.LogoutUrl}/${promotionSlug}/logout`;
        const config = {
            headers: {
                [AccessTokenAuth.HeaderName]: AccessTokenAuth.GetHeaderValue(),
            },
        };
        axios
            .post(logoutUrl, {}, config)
            .then(() => {
                AccessTokenAuth.DeleteAccessToken();
                dispatch(resetPromotion());
                userMutation.mutate({});
                // navigate(0);
            })
            .catch((error) => {
                AccessTokenAuth.DeleteAccessToken();
                dispatch(resetPromotion());
                userMutation.mutate({});
                navigate(0);
            });
    });
}
